import React from 'react';

export const IconTick = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.8637 4.13617C14.1566 4.42907 14.1566 4.90394 13.8637 5.19683L7.19701 11.8635C6.90411 12.1564 6.42924 12.1564 6.13635 11.8635L2.80301 8.53017C2.51012 8.23727 2.51012 7.7624 2.80301 7.46951C3.09591 7.17661 3.57078 7.17661 3.86367 7.46951L6.66668 10.2725L12.803 4.13617C13.0959 3.84328 13.5708 3.84328 13.8637 4.13617Z" />
  </svg>
);
